export const EMAIL = /^([a-zA-Z0-9_\.\-\+\'])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,})+$/;
export const PHONE = /^\([2-9][0-9]{2}\) *[0-9]{3}-[0-9]{4}$/;
export const NEW_PHONE_REGEX = /^(52-)?[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
export const NOT_DIGITS = /\D/g;
export const PHONE_DIGITS_ONLY = /^(\d{2})?(\d{3})(\d{3})(\d{4})$/;